import { createSelector } from 'reselect';

import { coworkingSelector } from '../root/coworkingSelector';

export const getCoworkingOffersSelector = createSelector(coworkingSelector, coworking => coworking?.offers || []);
